<sew-headline level="5">{{ 'ORDER_TABLE.POSITION_TITLE' | translate: { orderNumber } }}</sew-headline>
@if (rows && rows.length > 0) {
    <osc-base-table
        [items]="rows"
        [columns]="['positionNumber', 'description', 'externalReference', 'search']"
        [hideMarkedBar]="true"
        [showCheckboxColumn]="false"
    >
        <ng-container cdkColumnDef="positionNumber">
            <th cdk-header-cell *cdkHeaderCellDef>
                <osc-text-table-header
                    [name]="'ORDER_TABLE.POSITION' | translate"
                    class="header-availability"
                ></osc-text-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">{{ row.rowData.positionNumber }}</td>
        </ng-container>
        <ng-container cdkColumnDef="description">
            <th cdk-header-cell *cdkHeaderCellDef>
                <osc-text-table-header
                    [name]="'SPARE_PARTS.TABLE.PART_NAME' | translate"
                    class="header-availability"
                ></osc-text-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">{{ row.rowData.description }}</td>
        </ng-container>
        <ng-container cdkColumnDef="externalReference">
            <th cdk-header-cell *cdkHeaderCellDef>
                <osc-text-table-header
                    [name]="'ORDER_TABLE.CUSTOMER_MATERIAL_NUMBER' | translate"
                    class="header-availability"
                ></osc-text-table-header>
            </th>
            <td cdk-cell *cdkCellDef="let row">{{ row.rowData.externalReference }}</td>
        </ng-container>
        <ng-container cdkColumnDef="search">
            <th cdk-header-cell *cdkHeaderCellDef></th>
            <!-- #499174 disable button if canceled or reconfirmation awaiting -->
            <td cdk-cell *cdkCellDef="let row">
                <ng-template #tooltipWasCanceled>
                    <osc-default-tooltip>
                        {{ 'SPARE_PARTS_LIST.TABLE.TOOLTIP.POS_CANCELED' | translate }}
                    </osc-default-tooltip>
                </ng-template>
                <ng-template #tooltipNeedsReconfirmation>
                    <osc-default-tooltip>
                        {{ 'SPARE_PARTS_LIST.TABLE.TOOLTIP.POS_RECONFIRMATION' | translate }}
                    </osc-default-tooltip>
                </ng-template>
                <!-- set tooltip to wrapper span because disabled elements dont allow tooltip -->
                <span
                    [oscTooltip]="
                        row.rowData.status.code === 'IS'
                            ? tooltipWasCanceled
                            : row.rowData.status.code === 'I0'
                              ? tooltipNeedsReconfirmation
                              : null
                    "
                >
                    <sew-button hierarchy="secondary" size="xs" icon="arrow-chevron-right">
                        <button
                            (click)="openSearchInNewTab(row.rowData.id)"
                            [disabled]="
                                row.isDisabled ||
                                row.rowData.status.code === 'IS' ||
                                row.rowData.status.code === 'I0'
                            "
                        >
                            {{ 'SPARE_PARTS_LIST.TABLE.SHOW' | translate }}
                        </button>
                    </sew-button>
                </span>
            </td>
        </ng-container>
        <ng-container cdkColumnDef="expandableRow"> </ng-container>
        <ng-container cdkColumnDef="fullRowContent"> </ng-container>
        <ng-container cdkColumnDef="groupHeaderIcon"> </ng-container>
        <ng-container cdkColumnDef="groupHeaderName"> </ng-container>
    </osc-base-table>
} @else {
    <ecs-part-table-skeleton [showGroupHeader]="false" [rowCount]="9"></ecs-part-table-skeleton>
}
